import Axios from 'axios';

class DafApi {
  /**
   * Method used to login.
   *
   * @returns {Promise} The result in a promise.
   */
  static createDafOrgUser(orgAndUser) {
    const session = JSON.parse(localStorage.getItem('session'));
    const config = {
      headers: { Authorization: `Bearer ${session.token}` },
      baseURL: process.env.API_DESKDAF,
      Accept: 'application/json',
    };
    const instance = Axios.create(config);
    return instance.post('/admin/organization', orgAndUser);
  }

  static fetchDeskrhServices(orgList) {
    const session = JSON.parse(localStorage.getItem('session'));
    const config = {
      headers: { Authorization: `Bearer ${session.token}` },
      baseURL: process.env.API_DESKRH,
      Accept: 'application/json',
    };
    const instance = Axios.create(config);
    return instance.post('/organizations/managed', orgList);
  }

  static fetchDafServices(orgList) {
    const session = JSON.parse(localStorage.getItem('session'));
    const config = {
      headers: { Authorization: `Bearer ${session.token}` },
      baseURL: process.env.API_DESKDAF,
      Accept: 'application/json',
    };
    const instance = Axios.create(config);
    return instance.post('/organizations/managed', orgList);
  }
}

export default DafApi;



// WEBPACK FOOTER //
// ./src/api/DafApi.js